import cn from 'classnames';
import Image from 'next/image';
import { FC, useMemo } from 'react';

import { CheckCircleTwoTone } from '@ant-design/icons';

import { getCardImage } from '~utils/getCardImage';

import { CardType, PaymentMethod } from '~types';

import styles from './CardThumbnail.module.css';

interface Props {
  data: PaymentMethod;
  selected?: boolean;
  onSelect: (item: PaymentMethod) => void;
  onDeselect: () => void;
}

const CardThumbnail: FC<Props> = ({ data, selected = false, onSelect, onDeselect }) => {
  const lastFour = data.last4;

  const cardImageSource = useMemo(() => getCardImage(data.brand as CardType), [data.brand]);

  return (
    <div
      role="button"
      onClick={() => {
        if (!selected) {
          onSelect(data);
        } else {
          onDeselect();
        }
      }}
      className={cn(styles.root, { [styles.selected]: selected })}
    >
      <div className={styles.cardHeader}>
        <div className={styles.cardName}>
          <span className={styles.cardLabel}>{data.name}</span>
        </div>
        <div className={styles.cardType}>
          {selected ? (
            <CheckCircleTwoTone
              twoToneColor="#E5322C"
              style={{ fontSize: 20, verticalAlign: 'top' }}
            />
          ) : (
            cardImageSource && (
              <Image
                width={26}
                height={20}
                className="object-contain"
                src={cardImageSource}
                alt="Icono de la tarjeta de crédito"
              />
            )
          )}
        </div>
      </div>
      <div className={styles.cardNumber}>
        <span>&bull;&bull;&bull;&bull;</span>
        <span>&bull;&bull;&bull;&bull;</span>
        <span>&bull;&bull;&bull;&bull;</span>
        <span>{lastFour}</span>
      </div>
      <div className={styles.cardFooter}>
        <div className={styles.cardHolder}>
          <span className={styles.cardLabel}>Titular</span>
          <span className="line-clamp-1">{data.cardHolder}</span>
        </div>
        <div className={styles.cardExp}>
          <span className={styles.cardLabel}>Exp.</span>
          <span>{`${data.expMonth}/${data.expYear}`}</span>
        </div>
      </div>
    </div>
  );
};

export default CardThumbnail;
